import Kind from './Kind'

export default Kind
